import React, {Component, Fragment} from 'react';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";
import config from "../../../config";
import i18n from "../../../i18n";
import {GelContentContainer,  FormBack, ResultsCounterTermed, Sanitize} from 'cw-styleguide-react';
import AutocompleteSearch from "../../../components/AutocompleteSearch";
import Tabs from "../../../components/Tabs";
import Helmet from 'react-helmet';

class IndustriesDetailView extends Component {
  render() {
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.data.name} | {this.props.t('route_industry_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route("industries") + route('industry', {industry: this.props.slug})}>
          {this.props.data.name}
        </BreadcrumbsItem>
        <AutocompleteSearch  jobs={this.props.jobs}/>
        <GelContentContainer>
          <Tabs/>
          <FormBack url={route('industries')} title={this.props.data.name} theme={['secondary']}/>
          <h2>{this.props.data.name}</h2>
          <Sanitize html={this.props.data.description} classes={['style--list-circle','style--list-no-bg']}/>
          <ResultsCounterTermed count={this.props.data.jobs.length} item={this.props.t('job_titles')}
                                category={this.props.data.name}/>
          <ul className="style--columns-3 style--list-plain style--list-large">
            {this.props.data.jobs.map((job, index) => {
              return (
                <li key={index}>
                  <a className={'anchor-list__link gel-md-mb-20'}
                     href={config.basePath[i18n.language] + route('job', {job: job.slug})}>{job.name}</a>
                </li>
              );
            })}
          </ul>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(IndustriesDetailView);
